interface GetButtonsConfigProps {
  view: 'list' | 'map'
  filterPresentation: 'expanded' | 'collapsed'
  actions: {
    openMap: () => void
    openList: () => void
    collapseFilters: () => void
    expandFilters: () => void
  }
}

interface GetButtonsConfigResult {
  firstButton: {
    label: string
    onClick: () => void
  }
  secondButton?: {
    label: string
    /*
     * Names from the design-icons union. The prop lets `WButton` size the icon,
     * which is what keeps this button the same height as `Ver lista`.
     */
    icon: 'icArrowExpand1' | 'icClose'
    onClick: () => void
  }
}

const getMobileButtonsConfig = ({
  view,
  filterPresentation,
  actions
}: GetButtonsConfigProps): GetButtonsConfigResult => {
  /* In list view the pair is fixed: `Ver mapa` and the magnifier. */
  if (view === 'list') {
    return {
      firstButton: {
        label: 'Ver mapa',
        onClick: actions.openMap
      }
    }
  }

  /* `Ver lista` carries no icon: node 65:81091 shows the label alone. */
  const buttons = {
    firstButton: {
      label: 'Ver lista',
      onClick: actions.openList
    }
  }

  return filterPresentation === 'expanded'
    ? {
        ...buttons,
        secondButton: {
          label: 'Ampliar mapa',
          icon: 'icArrowExpand1',
          onClick: actions.collapseFilters
        }
      }
    : {
        ...buttons,
        secondButton: {
          label: 'Fechar mapa',
          icon: 'icClose',
          onClick: actions.expandFilters
        }
      }
}

export { getMobileButtonsConfig }
